import { Button, ConfigProvider } from 'antd'
import React from 'react'

import type { ButtonProps, ThemeConfig } from 'antd'

export interface ThemeButtonProps extends ButtonProps {
  theme?: ThemeConfig
}

const ThemeButton: React.FC<ThemeButtonProps> = (props) => {
  const { theme, ...rest } = props

  return (
    <ConfigProvider theme={theme}>
      <Button {...rest} />
    </ConfigProvider>
  )
}

export default ThemeButton
